/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Pozastaveno`
};

const da_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Holdt tilbage`
};

const de_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Zurückgestellt`
};

const en_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Holded`
};

const es_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Retenido`
};

const fr_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Bloqué`
};

const hu_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Blokkolva`
};

const it_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Bloccato`
};

const nl_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `In de wacht`
};

const pl_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Wstrzymane`
};

const pt_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Retido`
};

const sv_order_states_holded = /** @type {(inputs: {}) => string} */ () => {
	return `Pausad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_states_holded = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_states_holded(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_states_holded", locale)
	if (locale === "cs") return cs_order_states_holded(inputs)
	if (locale === "da") return da_order_states_holded(inputs)
	if (locale === "de") return de_order_states_holded(inputs)
	if (locale === "en") return en_order_states_holded(inputs)
	if (locale === "es") return es_order_states_holded(inputs)
	if (locale === "fr") return fr_order_states_holded(inputs)
	if (locale === "hu") return hu_order_states_holded(inputs)
	if (locale === "it") return it_order_states_holded(inputs)
	if (locale === "nl") return nl_order_states_holded(inputs)
	if (locale === "pl") return pl_order_states_holded(inputs)
	if (locale === "pt") return pt_order_states_holded(inputs)
	return sv_order_states_holded(inputs)
};
export { order_states_holded as "order_states.holded" }